import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Text } from '@/components/shared/components/Text';

export const TotalAlert = () => {
  return (
    <CustomCartAlert severity={'error'} icon={'error'}>
      <Text tId={'CART_ALERT_ARTICLE_TOTAL'}></Text>
    </CustomCartAlert>
  );
};
